import React from "react";
import { DeploymentRequestDetailPageInitialState, PageNewState } from ".";

export const DeploymentRequestDetailPageContext = React.createContext({
  pageState: DeploymentRequestDetailPageInitialState,
  setPageState: (pageState: PageNewState) => {},
});
